// Jedno miejsce konfiguracji treści strony — opinie, screeny i promocję podmienisz tutaj.

export const ORDER_URL =
  "https://online.edunation.com.pl/s/kurs-online-umiem-uczyc-iiedycja.html";
export const REGULAMIN_URL = "https://edunation.com.pl/regulamin/";

// Wspólny moment końca promocji: 2026-10-21T00:00:00+02:00 (północ z 20 na 21 października, czas polski)
export const PROMO_END_ISO = "2026-10-21T00:00:00+02:00";
export const PROMO_DEADLINE_TEXT =
  "Promocja tylko do 20 października 2026, do północy";

export const NAV_ITEMS = [
  { label: "O kursie", href: "#o-kursie" },
  { label: "Zajrzyj do kursu", href: "#podglad" },
  { label: "Program", href: "#program" },
  { label: "Prowadzące", href: "#prowadzace" },
  { label: "Pytania", href: "#pytania" },
  { label: "Cena", href: "#cena" },
];

export const APPLICATIONS = [
  {
    title: "Planowanie lekcji",
    text: "Jak układać cele i kolejne etapy lekcji.",
  },
  {
    title: "Mówienie i reakcja na błędy",
    text: "Jak zachęcać uczniów do wypowiedzi i reagować na błędy.",
  },
  {
    title: "Gramatyka i słownictwo",
    text: "Jak tłumaczyć znaczenie i przechodzić do ćwiczeń.",
  },
  {
    title: "Zarządzanie grupą",
    text: "Jak wprowadzać zasady, dawać instrukcje i monitorować pracę.",
  },
];

export const WARTO_WIEDZIEC = [
  "dla początkujących nauczycieli",
  "dla nauczycieli doświadczonych",
  "omówiony każdy element nauczania języka angielskiego",
  "bez rzetelnej metodyki ani rusz",
  "praktyczne pomysły",
];

export const CERTYFIKAT_NOTE =
  "Kurs zakończy się testem sprawdzającym wiedzę. Certyfikat uczestnictwa otrzyma każdy, kto uzyska minimum 80% punktów w teście.";

export const KORZYSCI = [
  "praktyczne wskazówki podane w przystępny sposób",
  "rzetelna metodyka od znakomitych trenerek",
  "powtórzenie i odświeżenie wiedzy",
];

export const DLA_KOGO = [
  "Uczysz od niedawna i potrzebujesz więcej rzetelnej wiedzy.",
  "Uczysz od dawna, ale czujesz, że powtórka metodyki dobrze Ci zrobi.",
  "Nigdy nie uczyłaś/łeś i chcesz zacząć się przygotowywać.",
];

// Prawdziwe screeny platformy kursu (dostarczone przez właścicielkę).
export const GALLERY = [
  {
    id: "podglad-1",
    src: "/assets/nowa-1.png",
    alt: "Widok platformy kursu: karty lekcji modułów 1–5 z tytułami i czasem trwania nagrań",
    caption: "Lekcje modułów 1–5 na platformie kursu",
  },
  {
    id: "podglad-2",
    src: "/assets/nowa-2.png",
    alt: "Widok platformy kursu: karty lekcji modułów 10–14 oraz pierwsza lekcja modułu dodatkowego",
    caption: "Lekcje modułów 10–14 na platformie kursu",
  },
  {
    id: "podglad-3",
    src: "/assets/nowa-4.png",
    alt: "Widok platformy kursu: lekcje 1–8 modułu dodatkowego o zarządzaniu grupą",
    caption: "Moduł dodatkowy — lekcje 1–8 na platformie kursu",
  },
  {
    id: "podglad-4",
    src: "/assets/nowa-3.png",
    alt: "Widok platformy kursu: lekcje 2–9 modułu dodatkowego o zarządzaniu grupą",
    caption: "Moduł dodatkowy — lekcje 2–9 na platformie kursu",
  },
];

// Prawdziwe opinie uczestniczek szkoleń eduNation (źródło: 100.edunation.com.pl).
export const TESTIMONIALS = [
  {
    id: "opinia-1",
    text: "To, co szczególnie cenię, to praktyczność — zero teorii do szuflady, tylko konkret, który mogłam od razu wdrożyć w mojej szkole. Zaczęłam inaczej patrzeć na zespół, na uczniów, na siebie.",
    signature: "Przygoda z angielskim",
    note: "opinia o szkoleniach EduNation",
  },
  {
    id: "opinia-2",
    text: "Wasze tematy z Edunation wykorzystuję na zajęciach! To miło słyszeć, jak uczniowie mówią: Ale ta lekcja była faaajna! Dziękuję Wam, że podając nam pomysły projektów, kreatywnych zajęć do realizacji, dajecie radość uczniom z nauki! To Wielka Sztuka! DZIĘKUJĘ!",
    signature: "Iwona S.",
    note: "opinia o szkoleniach EduNation",
  },
  {
    id: "opinia-3",
    text: "Rewelacyjne, merytorycznie doskonałe kursy na najwyższym poziomie, łączące wiedzę z praktyką, zaangażowanie ze sprawdzonymi faktami i umiejętność przekazywania wiedzy z zarażaniem entuzjazmem. Wystarczy żeby czerpać pełnymi garściami!",
    signature: "Anna K.",
    note: "opinia o szkoleniach EduNation",
  },
];

export const MODULES = [
  {
    number: 1,
    title: "Jak planować kurs i jak planować pojedyncze lekcje angielskiego?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Jak budować sekwencje z części lekcji?",
      "Lekcja 2. Jak powinien wyglądać plan lekcji?",
      "Lekcja 3. Planowanie celów lekcji.",
      "Lekcja 4. Planowanie całego kursu.",
      "Lekcja 5. Jak budować swoje oczekiwania względem uczniów?",
    ],
  },
  {
    number: 2,
    title: "JAK UCZYĆ GRAMATYKI?",
    trainers: ["Monika Cichmińska"],
    lessons: [
      "Lekcja 1. Co to jest gramatyka?",
      "Lekcja 2. Jak tłumaczyć gramatykę?",
      "Lekcja 3. Jak pokazywać znaczenie?",
      "Lekcja 4. Jak ćwiczyć w kontrolowany sposób?",
      "Lekcja 5. Jak pomagać uczniom mówić z użyciem danej struktury?",
    ],
  },
  {
    number: 3,
    title: "JAK UCZYĆ SŁOWNICTWA?",
    trainers: ["Agnieszka Cyluk"],
    lessons: [
      "Lekcja 1. Co znaczy, że znamy jakieś słowo?",
      "Lekcja 2. Jak tłumaczyć słownictwo?",
      "Lekcja 3. Jak pokazywać znaczenie słów?",
      "Lekcja 4. Jak ćwiczyć słownictwo w kontrolowany sposób?",
      "Lekcja 5. Jak pomagać uczniom mówić z użyciem danej struktury?",
    ],
  },
  {
    number: 4,
    title: "JAK UCZYĆ MÓWIENIA?",
    trainers: ["Monika Cichmińska"],
    lessons: [
      "Lekcja 1. Jak zachęcać do mówienia?",
      "Lekcja 2. Jak budować sekwencje ćwiczeń na mówienie?",
      "Lekcja 3. Jak poprawiać błędy w mówieniu?",
      "Lekcja 4. Co robić w trakcie, gdy uczeń mówi?",
    ],
  },
  {
    number: 5,
    title: "JAK UCZYĆ PISANIA?",
    trainers: ["Magda Zawadzka"],
    lessons: [
      "Lekcja 1. Jak dawać prawdziwy powód do pisania?",
      "Lekcja 2. Jak uczyć pisania od niskich poziomów?",
      "Lekcja 3. Jak zachęcać uczniów do pisania poza klasą?",
      "Lekcja 4. Jak budować sekwencje ćwiczeń na pisanie?",
      "Lekcja 5. Jak poprawiać pracę pisemną?",
    ],
  },
  {
    number: 6,
    title: "JAK UCZYĆ SŁUCHANIA?",
    trainers: ["Anna Popławska"],
    lessons: [
      "Lekcja 1. Czego i jak słuchamy, nie tylko na lekcji.",
      "Lekcja 2. Jakie materiały wybierać?",
      "Lekcja 3. Ćwiczenia przed, w trakcie i po słuchaniu.",
      "Lekcja 4. Jak zachęcać uczniów do słuchania poza klasą?",
      "Lekcja 5. Uczniowie na bardzo niskim poziomie zaawansowania",
    ],
  },
  {
    number: 7,
    title: "JAK UCZYĆ CZYTANIA?",
    trainers: ["Magda Zawadzka"],
    lessons: [
      "Lekcja 1. Jak dawać realny powód do czytania?",
      "Lekcja 2. Jakie są różne rodzaje czytania?",
      "Lekcja 3. Jak zachęcać uczniów do czytania poza klasą?",
      "Lekcja 4. Jak budować sekwencje ćwiczeń na czytanie?",
    ],
  },
  {
    number: 8,
    title: "JAK UCZYĆ WYMOWY?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Jakie typy aktywności pomogą uczniom lepiej wymawiać głoski?",
      "Lekcja 2. Jak ćwiczyć wymowę całych zdań i wyrażeń?",
    ],
  },
  {
    number: 9,
    title: "JAK POPRAWIAĆ BŁĘDY?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Kiedy poprawiać w trakcie wypowiedzi, a kiedy poza nią?",
      "Lekcja 2. Kiedy pozwalać uczniom poprawić się samym?",
      "Lekcja 3. Jak przeprowadzać rozwojowy feedback?",
    ],
  },
  {
    number: 10,
    title: "JAK TESTOWAĆ?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Po co testować?",
      "Lekcja 2. Co to jest dobry test?",
      "Lekcja 3. Jak projektować test i jakie są różne formaty zadań?",
      "Lekcja 4. Jak rzetelnie sprawdzać test?",
    ],
  },
  {
    number: 11,
    title: "JAK WPROWADZAĆ KONKRETNE TECHNIKI NAUCZANIA?",
    trainers: [
      "Anna Kozicka-Wanat",
      "Agnieszka Cyluk",
      "Gosia Klecuń",
      "Monika Cichmińska",
    ],
    lessons: [
      "Lekcja 1. Jak korzystać z flashcards? (Anna Popławska)",
      "Lekcja 2. Jak korzystać ze zdjęć? (Anna Popławska)",
      "Lekcja 3. Jak wprowadzać storytelling? (Anna Kozicka-Wanat)",
      "Lekcja 4. Piosenki i muzyka na lekcji. (Gosia Klecuń)",
      "Lekcja 5. Gry na słownictwo. (Agnieszka Cyluk)",
      "Lekcja 6. Dyktanda. (Monika Cichmińska)",
      "Lekcja 7. Drama (Anna Kozicka-Wanat)",
    ],
  },
  {
    number: 12,
    title: "JAK KORZYSTAĆ Z PODRĘCZNIKA?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Jak dokonywać selekcji materiału?",
      "Lekcja 2. Jak uzupełniać i adaptować materiał?",
      "Lekcja 3. Jak wybrać dobry podręcznik?",
      "Lekcja 4. Podręcznik: powody za i powody przeciwko.",
    ],
  },
  {
    number: 13,
    title:
      "JAKIE SĄ GŁÓWNE RÓŻNICE W UCZENIU ANGIELSKIEGO DZIECI, MŁODZIEŻY I DOROSŁYCH?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Charakterystyka pracy z dziećmi.",
      "Lekcja 2. Charakterystyka pracy z młodzieżą.",
      "Lekcja 3. Charakterystyka pracy z dorosłymi.",
    ],
  },
  {
    number: 14,
    title: "JAK UCZYĆ PRZY UŻYCIU NOWOCZESNYCH TECHNOLOGII?",
    trainers: ["Anna Popławska"],
    lessons: [
      "Lekcja 1. Jak mądrze korzystać z nowoczesnych technologii na lekcji i nie pogubić się w gąszczu możliwości? Jak się zorganizować?",
      "Lekcja 2. Nowoczesne technologie: dzieci, młodzież i dorośli.",
      "Lekcja 3. Moje ulubione aplikacje: jak ich używam",
      "Lekcja 4. Tworzenie materiałów na lekcje.",
    ],
  },
  {
    number: 15,
    isNew: true,
    title: "Jak zarządzać grupą na lekcjach języka angielskiego?",
    trainers: ["Luiza Wójtowicz-Waga"],
    lessons: [
      "Lekcja 1. Czemu zarządzanie, a nie dyscyplina?",
      "Lekcja 2. Jak wprowadzać zasady i kontraktować się z uczniem?",
      "Lekcja 3. Jak mówić, żeby nie krzyczeć? Jak mówić, gdy nikt Cię nie słucha?",
      "Lekcja 4. Przestań tyle mówić: gesty i mimika to też zarządzanie.",
      "Lekcja 5. Jak zarządzać dużą grupą uczniów (12+), dzielić na podgrupy i monitorować ich pracę?",
      "Lekcja 6. Kiedy dawać instrukcje, kiedy zadawać pytania, a kiedy to uczeń ma być źródłem?",
      "Lekcja 7. Jak dawać feedback i jak chwalić? A kiedy nie?",
      "Lekcja 8. W tej klasie nikt się nie schowa! Jak mądrze zarządzić przestrzenią?",
      "Lekcja 9. Jak radzić sobie, gdy Cię „trafia” i za chwilę wyjdziesz z siebie?",
    ],
  },
];

export const TRAINERS = [
  { id: "magda-zawadzka", name: "Magda Zawadzka", photo: "/assets/magda-zawadzka.png" },
  { id: "luiza-wojtowicz-waga", name: "Luiza Wójtowicz-Waga", photo: "/assets/luiza-wojtowicz-waga.png" },
  { id: "gosia-klecun", name: "Gosia Klecuń", photo: "/assets/gosia-klecun.png" },
  { id: "monika-cichminska", name: "Monika Cichmińska", photo: "/assets/monika-cichminska.png" },
  { id: "agnieszka-cyluk", name: "Agnieszka Cyluk", photo: "/assets/agnieszka-cyluk.png" },
  { id: "anna-poplawska", name: "Anna Popławska", photo: "/assets/anna-poplawska.png" },
  { id: "anna-kozicka-wanat", name: "Anna Kozicka-Wanat", photo: "/assets/anna-kozicka-wanat.png" },
];

export const FAQ = [
  {
    id: "nagrania",
    q: "Czy lekcje są nagrane i mogę oglądać je w dowolnym czasie?",
    a: "Tak. Kurs składa się z nagranych lekcji, które możesz oglądać w dogodnym dla siebie czasie przez 10 miesięcy od daty zakupu.",
  },
  {
    id: "dostep",
    q: "Kiedy otrzymam dostęp do kursu?",
    a: "Kurs jest już gotowy i dostępny od ręki. Dostęp otrzymasz od razu po zakupie.",
  },
  {
    id: "okres",
    q: "Od kiedy liczy się 10 miesięcy dostępu?",
    a: "Okres dostępu rozpoczyna się w dniu zakupu kursu i trwa 10 miesięcy.",
  },
  {
    id: "dlugosc",
    q: "Ile trwają lekcje?",
    a: "Lekcje trwają od 15 min do 50 min.",
  },
  {
    id: "test",
    q: "Jak wygląda test i czy mogę go powtórzyć?",
    a: "Kurs kończy się testem z pytaniami zamkniętymi. Jeśli nie uzyskasz wymaganego wyniku, możesz wrócić do materiałów i ponownie przystąpić do testu. Test można powtarzać w okresie dostępu do kursu.",
  },
  {
    id: "certyfikat",
    q: "Jak otrzymam certyfikat?",
    a: "Po uzyskaniu minimum 80% punktów w teście otrzymasz certyfikat uczestnictwa w wersji elektronicznej.",
  },
  {
    id: "faktura",
    q: "Czy otrzymam fakturę?",
    a: "Tak, wystawiamy faktury. Jeśli potrzebujesz faktury na szkołę, skontaktuj się z nami: ewa.sierenska@edunation.com.pl.",
  },
];

export const TICKET_POINTS = [
  "69 praktycznych lekcji online",
  "certyfikat w wersji elektronicznej",
  "dostęp do kursu na 10 miesięcy",
];

// Linki do zamówień pakietów Mini/Maxi zostaną dostarczone przez właścicielkę.
export const PACKAGES = [
  {
    id: "pakiet-mini",
    badge: "Pakiet Mini",
    name: "Kurs + 2 Pigułki Wiedzy",
    image: "/assets/pakiet-mini.jpeg",
    imageAlt:
      "Pakiet Mini: kurs Umiem uczyć angielskiego oraz Pigułki Wiedzy o gramatyce i grupach o zróżnicowanym poziomie na ekranach laptopa i tabletów",
    items: [
      { label: "Kurs Umiem Uczyć Angielskiego" },
      {
        label: "Pigułka Wiedzy: Jak uczyć w grupach o zróżnicowanym poziomie?",
        pigulka: "grupy",
      },
      { label: "Pigułka Wiedzy: Jak uczyć gramatyki?", pigulka: "gramatyka" },
    ],
    price: "469 zł",
    regular: "807 zł",
    savings: "338 zł",
    cta: "Wybieram pakiet Mini",
    href: "https://online.edunation.com.pl/s/kurs-online-umiem-uczyc-mini-pakiet.html",
  },
  {
    id: "pakiet-maxi",
    badge: "Pakiet Maxi",
    name: "Kurs + 5 Pigułek Wiedzy",
    image: "/assets/pakiet-maxi.jpeg",
    imageAlt:
      "Pakiet Maxi: kurs Umiem uczyć angielskiego oraz pięć Pigułek Wiedzy na ekranach laptopa i tabletów",
    items: [
      { label: "Kurs Umiem Uczyć Angielskiego" },
      {
        label: "Pigułka Wiedzy: Jak uczyć w grupach o zróżnicowanym poziomie?",
        pigulka: "grupy",
      },
      { label: "Pigułka Wiedzy: Jak uczyć gramatyki?", pigulka: "gramatyka" },
      { label: "Pigułka wiedzy: Umiem uczyć słownictwa?", pigulka: "slownictwo" },
      { label: "Pigułka Wiedzy: Jak uczyć pisania?", pigulka: "pisanie" },
      { label: "Pigułka Wiedzy: Jak uczyć słuchania?", pigulka: "sluchanie" },
    ],
    price: "679 zł",
    regular: "1644 zł",
    savings: "965 zł",
    cta: "Wybieram pakiet Maxi",
    href: "https://online.edunation.com.pl/s/kurs-online-umiem-uczyc-maxi-pakiet.html",
    highlight: "Najwięcej materiałów",
  },
];

// Pigułki Wiedzy — programy zgodne ze stroną edunation.com.pl/pigulkiwiedzy/
export const PIGULKI = [
  {
    id: "gramatyka",
    title: "Jak uczyć gramatyki?",
    short:
      "Poznaj zasady efektywnego nauczania gramatyki w komunikacyjnym ujęciu. Od budowy lekcji, przez gry i zabawy, po analizę błędów i pracę z materiałami autentycznymi.",
    trainer: "Agnieszka Bałdyga-Gorzkowski",
    lessons: [
      "Wprowadzenie do gramatyki jako kluczowego elementu komunikacji. Omówienie, dlaczego rozumienie i nauka gramatyki są tak ważne w nauce języka oraz w jaki sposób gramatyka wspiera skuteczną wymianę myśli i rozumienie tekstów.",
      "Jak nauczać gramatyki kontekstowo i jak dobierać ćwiczenia, które uczą struktury gramatycznej poprzez rzeczywiste sytuacje i konteksty komunikacyjne, dzięki czemu gramatyka staje się naturalnym elementem komunikacji.",
      "Omówienie kluczowych elementów dobrze zaplanowanej lekcji gramatyki. Skupimy się na modelach prezentacji gramatyki, wprowadzania i utrwalania nowych struktur oraz na praktycznych ćwiczeniach, które wspierają uczniów w przyswajaniu nowych zasad.",
      "Techniki tłumaczenia gramatyki oraz pokazania znaczenia w sposób jasny i zrozumiały, z naciskiem na użycie przykładów z kontekstu, materiałów wizualnych (diagramy, schematy) oraz aplikacji multimedialnych.",
      "Omówienie kontrolowanych ćwiczeń gramatycznych: jak skutecznie przeprowadzać ćwiczenia typu „drill” oraz zadania z ustrukturyzowaną kontrolą, aby uczniowie mogli przećwiczyć nowe struktury przed swobodnym użyciem.",
      "Skupimy się na technikach i ćwiczeniach, które wspierają uczniów w stosowaniu poznanych struktur gramatycznych w praktyce, zarówno w mowie, jak i w piśmie, aby zwiększyć ich płynność i pewność w użyciu języka.",
      "Poznamy, jak można wykorzystać gry, zabawy i ćwiczenia grupowe, aby uczynić naukę gramatyki bardziej atrakcyjną. Wykorzystanie elementów zabawowych zwiększa motywację uczniów i angażuje ich w proces nauki.",
      "Praca z tekstami, nagraniami i dialogami, które ukazują użycie gramatyki w codziennej komunikacji. Uczniowie zobaczą, jak gramatyka funkcjonuje w rzeczywistych kontekstach, co pomaga im lepiej rozumieć jej zastosowanie.",
      "Praktyczne wskazówki na temat oceny postępów uczniów i monitorowania ich znajomości gramatyki. Skupimy się na sposobach oceny, udzielaniu feedbacku oraz na tym, jak nauczyciel może pomóc uczniom w samodzielnej ocenie swoich umiejętności.",
      "Omówienie praktycznych zadań gramatycznych, które pozwalają uczniom samodzielnie stosować gramatykę. Skupimy się na analizie typowych błędów oraz technikach ich korekty, aby uczniowie mogli zrozumieć swoje błędy i się na nich uczyć.",
    ],
  },
  {
    id: "slownictwo",
    title: "Umiem uczyć słownictwa?",
    short:
      "Rozwijaj zasoby leksykalne uczniów dzięki technikom, które aktywizują pamięć i utrwalają nowe słowa, kolokacje i wyrażenia idiomatyczne.",
    trainer: "Magdalena Zawadzka",
    lessons: [
      "Wprowadzenie do roli słownictwa w procesie komunikacji. Omówimy, co to znaczy „znać słowo” i jak poziom zasobu leksykalnego ucznia wpływa na jego umiejętności komunikacyjne oraz rozumienie tekstów i wypowiedzi.",
      "Poznamy techniki wprowadzania nowych słów: od tłumaczenia i pokazywania znaczenia, po kreatywne techniki kontekstowe. Przeanalizujemy, jak zapewnić uczniom pełne zrozumienie nowo wprowadzanych słów oraz ich funkcji w komunikacji.",
      "Jak uczyć słownictwa w naturalnym kontekście? Skupimy się na technikach kontekstualizacji, takich jak użycie tekstów, sytuacji dialogowych oraz materiałów wizualnych, aby nowe słowa były lepiej zapamiętywane i używane w naturalnych sytuacjach.",
      "Techniki mnemotechniczne (np. skojarzenia, rymy, akronimy), które wspierają proces zapamiętywania słów i ich znaczeń. Nauczymy się, jak wspierać uczniów w długoterminowej pamięci słownictwa dzięki ćwiczeniom aktywizującym ich wyobraźnię i skojarzenia.",
      "Omówimy efektywne wykorzystanie fiszek, aplikacji i kart pracy do nauki słownictwa. Przedstawimy różne narzędzia, dzięki którym uczniowie mogą samodzielnie ćwiczyć i utrwalać nowe słowa poza lekcją, co wspiera ich autonomię w nauce.",
      "Gry i zabawy jako narzędzia do utrwalania słownictwa. Przedstawimy różnorodne zabawy językowe i ćwiczenia, które nie tylko angażują, ale również pomagają uczniom w aktywnym użyciu i powtarzaniu nowych słów.",
      "Skupimy się na nauczaniu kolokacji oraz idiomów. Omówimy techniki ułatwiające przyswajanie wyrażeń charakterystycznych dla języka, które zwiększają płynność i naturalność wypowiedzi uczniów.",
      "Jak prowadzić ćwiczenia powtórzeniowe, aby uczniowie skutecznie utrwalili nowe słownictwo. Poznamy techniki powtórzeń, dzięki którym słownictwo zostaje w pamięci długoterminowej, a uczniowie czują się pewniej w jego stosowaniu.",
      "Jak skutecznie wprowadzać słownictwo specjalistyczne w różnych kontekstach (np. słownictwo biznesowe, techniczne). Nauczymy się, jak pracować z tekstami specjalistycznymi, aby uczniowie nabywali słownictwo użyteczne w ich środowisku zawodowym.",
      "Techniki oceny i monitorowania rozwoju zasobu słownictwa uczniów. Skupimy się na różnych formach sprawdzania wiedzy leksykalnej, monitorowaniu postępów oraz udzielaniu informacji zwrotnej, aby motywować uczniów do dalszej nauki.",
    ],
  },
  {
    id: "pisanie",
    title: "Umiem uczyć pisania?",
    short:
      "Wprowadź efektywne strategie rozwijania umiejętności pisania na różnych poziomach — od kreatywnych wypracowań, po pisanie formalne i akademickie. Naucz się, jak efektywnie korygować i oceniać prace pisemne uczniów.",
    trainer: "Agnieszka Bałdyga-Gorzkowski",
    lessons: [
      "Wprowadzenie do nauczania pisania: dlaczego pisanie jest kluczowe dla rozwijania pełnych kompetencji językowych. Jak dać uczniom rzeczywisty powód do pisania, który zwiększy ich zaangażowanie w ćwiczenia pisemne.",
      "Jak uczyć podstaw pisania na niższych poziomach zaawansowania. Omówimy podejście stopniowe, które buduje umiejętność tworzenia zdań, a potem dłuższych form pisemnych, od prostych ćwiczeń po bardziej rozbudowane treści.",
      "Tworzenie efektywnej struktury lekcji pisania, uwzględniając elementy takie jak cel komunikacyjny, forma, struktura i styl tekstu. Wprowadzimy różne typy ćwiczeń, które pomagają uczniom rozwijać umiejętności pisemne.",
      "Jak wspierać uczniów w nauce pisania e-maili, listów, notatek, ogłoszeń i innych tekstów nieformalnych? Omówimy sposoby motywowania uczniów do pisania tego typu tekstów oraz techniki pomagające im opanować tę umiejętność.",
      "Uczymy zasad pisania formalnego, przydatnego w środowiskach zawodowych i akademickich. Przedstawimy ćwiczenia przygotowujące do tworzenia raportów, artykułów, listów oraz innych formalnych form pisania.",
      "Jak rozwijać kreatywność i indywidualny styl pisania uczniów. Omówimy techniki wspierające pisanie kreatywne oraz tworzenie dłuższych form pisemnych, takich jak eseje czy opowiadania, które rozwijają umiejętność swobodnego wyrażania myśli.",
      "Jak w ciekawy i efektywny sposób wspierać uczniów w opanowaniu umiejętności pisania formalnych tekstów prezentujących ich opinie i do nich przekonujących oraz nieformalnych form, takich jak reklama czy post sprzedażowy na social mediach.",
      "Jak prowadzić lekcje, gdzie uczniowie zdobywają umiejętność pisania barwnych opisów osób i miejsc? Pokażemy, jak możecie sprawić, by teksty Waszych uczniów były pełne detali, przymiotników i przysłówków oraz tworzyły wrażenia za pomocą zmysłów.",
      "Poznamy narzędzia cyfrowe, aplikacje i programy, które wspierają rozwój umiejętności pisania. Wprowadzenie do technologii, które ułatwiają pisanie, poprawę błędów oraz kreatywne ćwiczenia pisemne.",
      "Jak poprawnie analizować i korygować błędy w pracach uczniów. Omówimy techniki feedbacku, które nie tylko pomagają poprawiać błędy, ale również uczą samodzielnego doskonalenia się w pisaniu. Skuteczne monitorowanie postępów uczniów.",
    ],
  },
  {
    id: "sluchanie",
    title: "Umiem uczyć słuchania?",
    short:
      "Odkryj sprawdzone metody, które aktywizują umiejętność rozumienia ze słuchu. Nauczysz się, jak pracować z materiałami audio, filmami, podcastami i autentycznymi nagraniami, by uczyć skutecznie i interesująco.",
    trainer: "Magdalena Zawadzka",
    lessons: [
      "Wprowadzenie do nauczania umiejętności słuchania — dlaczego jest to kluczowy element w rozwoju językowym. Omówimy znaczenie aktywnego słuchania oraz sposoby angażowania uczniów w ćwiczenia słuchowe zarówno na lekcji, jak i poza nią.",
      "Jakie materiały wybierać, aby dopasować je do poziomu zaawansowania i zainteresowań uczniów? Poznamy różne typy treści, od dialogów codziennych po bardziej wymagające materiały, takie jak audycje czy wywiady, aby uczyć się słuchania na różnych poziomach.",
      "Omówimy techniki przygotowawcze, które pomogą uczniom lepiej zrozumieć tekst słuchany, zadania w trakcie słuchania ułatwiające koncentrację oraz działania po zakończeniu słuchania, które utrwalają i sprawdzają rozumienie.",
      "Jak zachęcać uczniów do ćwiczeń słuchowych poza lekcją? Poznamy pomysły na zadania domowe oraz zasoby (podcasty, aplikacje, filmy) do samodzielnego słuchania, które pomagają budować nawyk słuchania.",
      "Wyzwania w nauczaniu słuchania na niskim poziomie zaawansowania. Przedstawimy techniki ułatwiające zrozumienie prostych komunikatów oraz strategie wspomagające słuchanie i rozumienie na początku nauki języka.",
      "Nauka z wykorzystaniem autentycznych materiałów. Omówimy, jak dobierać filmy, podcasty, piosenki i inne treści, które przybliżają uczniom naturalny język oraz rozwijają umiejętność rozumienia akcentów i sytuacji życia codziennego.",
      "Jak zapoznać uczniów z różnorodnością języka? Przedstawimy sposoby na wprowadzanie materiałów zawierających różne akcenty oraz dialekty, które są kluczowe dla lepszego zrozumienia języka w kontekście międzynarodowym.",
      "Omówimy zadania, które pomagają utrwalać umiejętność słuchania, takie jak dyktanda, kluczowe pytania do tekstu oraz zadania wymagające szczegółowego zrozumienia. Ćwiczenia, które wspierają koncentrację na szczegółach i budowanie rozumienia całościowego.",
      "Jak analizować i omawiać błędy popełniane przez uczniów w trakcie słuchania oraz wspierać rozwój strategii pomagających w lepszym rozumieniu. Przedstawimy techniki, które pozwolą uczniom rozpoznać własne trudności i uczyć się efektywnego słuchania.",
      "Jak skutecznie oceniać rozwój słuchania u uczniów? Omówimy kryteria oceny oraz narzędzia i metody, które pozwalają monitorować progres, zarówno na poziomie lekcji, jak i długofalowo.",
    ],
  },
  {
    id: "grupy",
    title: "Jak uczyć w grupach o zróżnicowanym poziomie?",
    short:
      "Dowiedz się, jak skutecznie pracować z grupami mieszanymi poziomowo, dostosowywać materiały, angażować uczniów o różnych potrzebach i oceniać ich postępy w zróżnicowany sposób.",
    trainer: "Luiza Wójtowicz-Waga",
    lessons: [
      "Wprowadzenie do tematu pracy z grupami na różnych poziomach. Omówimy, jak efektywnie zarządzać takimi grupami i jakie korzyści edukacyjne oraz społeczne płyną z różnorodności w poziomach zaawansowania uczniów.",
      "Poznasz techniki dostosowywania treści i formy ćwiczeń do różnych poziomów uczniów, aby wszyscy mogli aktywnie uczestniczyć w lekcji. Wybór i adaptacja materiałów odpowiednich dla uczniów na różnych etapach nauki.",
      "Jak tworzyć i modyfikować zadania, aby jednocześnie wyzwalały zainteresowanie i były odpowiednie dla różnych poziomów. Przedstawimy sposoby na wprowadzenie zadań o zmiennym poziomie trudności w ramach jednej lekcji.",
      "Efektywne zarządzanie czasem to podstawa pracy z grupami o zróżnicowanym poziomie. Dowiesz się, jak organizować pracę na lekcji, by wszyscy uczniowie mieli możliwość zaangażowania i pracy we własnym tempie.",
      "Jak rozpoznawać i rozwijać mocne strony poszczególnych uczniów i wykorzystać je jako narzędzie w grupie, które wzbogaca doświadczenia innych. Techniki, które wspierają współpracę między uczniami na różnych poziomach.",
      "Zasady organizowania pracy w parach i grupach. Dowiesz się, jak dobierać uczniów do wspólnych zadań, by współpracowali efektywnie i uczyli się od siebie, a także jak kontrolować przebieg takich aktywności.",
      "Jak planować i prowadzić lekcje, które umożliwiają zaangażowanie wszystkich uczniów, niezależnie od poziomu zaawansowania? Techniki i podejścia, które aktywizują grupy mieszane.",
      "Omówimy, jak efektywnie oceniać uczniów w grupach mieszanych i udzielać konstruktywnej informacji zwrotnej. Techniki, które pomagają oceniać postępy zarówno indywidualne, jak i grupowe.",
      "Przedstawimy gotowe scenariusze lekcji oraz ćwiczenia, które można wykorzystać w grupach o różnym poziomie zaawansowania. Gotowe rozwiązania do wprowadzenia na lekcje i inspiracje do samodzielnego tworzenia materiałów.",
      "Jak obserwować rozwój umiejętności uczniów i monitorować ich postępy, aby motywować ich do dalszej nauki? Praktyczne wskazówki dotyczące indywidualnego i grupowego podejścia do oceny i motywowania w grupach mieszanych.",
    ],
  },
];

export const CONTACT = {
  name: "Ewa Siereńska",
  phone: "577 033 633",
  phoneHref: "tel:+48577033633",
  email: "ewa.sierenska@edunation.com.pl",
  hours: "PON. – PT. 10:00 – 18:00",
  photo: "/assets/kontakt-ewa.png",
};

export const MARQUEE_WORDS = [
  "planowanie lekcji",
  "mówienie",
  "gramatyka",
  "słownictwo",
  "pisanie",
  "słuchanie",
  "czytanie",
  "wymowa",
  "poprawianie błędów",
  "testowanie",
  "zarządzanie grupą",
];
